import axios, { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import pathfinder from '@fiverr-private/pathfinder';
import { Announcement } from '../types/announcementTypes';

export function useCurrentAnnouncements(): { data: Announcement[]; isLoading: boolean; error: AxiosError | null } {
    const params = new URLSearchParams({
        sellerVisible: 'true',
    });

    const { data, error, isLoading }: UseQueryResult<Announcement[], AxiosError> = useQuery({
        queryKey: ['go_all_announcements'],
        queryFn: async () => {
            const response = await axios.get(pathfinder('get_go_announcements'), { params });
            return response.data;
        },
    });

    return { data: data ?? [], isLoading, error };
}
